"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderSwitchTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.OrderSwitchTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    fromOrder: typebox_1.Type.String(),
    toOrder: typebox_1.Type.String(),
    type: typebox_1.Type.String(),
});
//# sourceMappingURL=order-switch-transport.js.map